import {inject, Injectable} from '@angular/core';
import {BaseModalService} from "../../services/base-modal.service";
import {RecordData} from "../../../../types/records-table.types";
import {AttachProps} from "../../../../types/attach-detach.types";
import {bloggerModalResourceType} from "../configs/blogger-modal-config";

@Injectable({
  providedIn: 'root'
})
export class NewBloggerProfileService {
  private baseModalService: BaseModalService = inject(BaseModalService);

  public createAttachProps(recordData: RecordData, bloggerContactId: number): AttachProps {
    return {
      recordCalendarId: this.baseModalService.getRecordCalendarId(recordData),
      id: bloggerContactId,
      path: bloggerModalResourceType.path
    };
  }
}
